export const API_ENDPOINTS = {
  LOOKUP: {
    CLIENTS: "/api/LookUp/Clients",
    FILE_STATUS: "/api/LookUp/FileStatus",
    TAX_YEARS: "/api/LookUp/TaxYears",
    PRINT_YEARS: "/api/LookUp/PrintYears",
    DATA_VALIDALIDATION_LEVELS: "/api/LookUp/DataValidationLevels",
    ROLES: "/api/LookUp/Roles",
    STATES: "/api/LookUp/StateCodes",
    FileTypes: "/api/LookUp/FileTypes",
    getFeinsByClientId: (clientId?: string) => `/api/LookUp/Feins/${clientId}`,
    ImportFileTypes: "/api/LookUp/ImportFileTypes",
    ValidationErrorTypes: "/api/LookUp/ValidationErrorTypes",
  },
  FILEMANAGEMENT: {
    FILE_HISTORY: "/api/FileHistory",
  },
  USERMANAGEMENT: {
    USER_MANAGEMENT: "/api/User/GetExternalUser",
    USER: `/api/User/GetExternalUserById/`,
    POST_USER: "/api/User/CreateExternalUser",
    PUT_USER: "/api/User/UpdateExternalUser",
    PUT_DISABLE_USER: "/api/User/Disable",
  },
  ACCOUNTSETTINGS: {
    ME: "/api/User/me",
  },
  CLIENTMANAGEMENT: {
    POST_CLINET_SETTINGS: "/api/Client",
    CLIENT_MANAGEMENT: "/api/Client",
    postFiles: (clientId: string, fileType: number, taxYear : number) =>
      `/api/FileIngestion/IngestFiles/${clientId}/${fileType}/${taxYear}`,
    getClientSettings: (clientId: string) => `/api/Client/${clientId}`,
    putClientSettings: (clientId: string) => `/api/Client/${clientId}`,
    putCompanySettings: (companySettingsId: string) =>
      `/api/Feins/UpdateFeinById/${companySettingsId}`,
    getAlternateReturnAddress: (clientId: string) =>
      `/api/Client/GetAlternateReturnAddress/${clientId}`,
    postAlternateReturnAddress: (clientId: string) =>
      `/api/Client/UpdateAlternateReturnAddress/${clientId}`,
    getUseAlternateReturnAddress: (clientId: string) =>
      `/api/Client/GetUseAlternateReturnAddress/${clientId}`,
    postUseAlternateReturnAddress: (clientId: string) =>
      `/api/Client/UpdateUseAlternateReturnAddress/${clientId}`,
    putEmployeeSettings: (internalEmployeeId: string) =>
      `/api/Employee/UpdateEmployeeById/${internalEmployeeId}`,
    postEmployeeSettings: `/api/Employee/CreateEmployee`,
    getStateFilingOptions: (clientId: string) =>
      `/api/Client/GetStateFilingDetails/${clientId}`,
    postUpdateStateFilingDetails: (clientId: string, taxYear: number) =>
      `/api/Client/UpdateStateFilingDetails/${clientId}/${taxYear}`,
    getAleGroup: (clientId: string, taxYear: number) =>
      `/api/Client/GetAdditionalAlems/${clientId}/${taxYear}`,
    createAleGroup: (clientId: string, taxYear: number) =>
      `/api/Client/CreateAdditionalAlem/${clientId}/${taxYear}`,
    updateAleGroup: "/api/Client/UpdateAdditionalAlem",
    deleteAleGroup: (clientadditionalAlemId: number) =>
      `/api/Client/DeleteAdditionalAlem/${clientadditionalAlemId}`,
    getEmployeeSettings: (companySettingsId: string) =>
      `/api/Feins/GetFeinById/${companySettingsId}`,
    getEmployeeFormData: (internalEmployeeId: string) =>
      `/api/Employee/GetEmployeeById/${internalEmployeeId}`,
    isEmployeeEligibleForPrintIndividual: (internalEmployeeId: string) =>
      `/api/Employee/IsEmployeeEligibleForPrintIndividual/${internalEmployeeId}`,    
    canCancelPrintIndividualRequest: (internalEmployeeId: string) =>
      `/api/Employee/CanCancelPrintIndividualRequest/${internalEmployeeId}`,
    createEmployeePrintIndividualRequest: "/api/Employee/CreateEmployeePrintIndividualRequest",
    cancelPrintIndividualRequest: (internalEmployeeId: string) =>
      `/api/Employee/CancelPrintIndividualRequest/${internalEmployeeId}`,
    getEmployeeStateFilingSettings: (internalEmployeeId: string) =>
      `api/Employee/GetEmployeeStateFilings/${internalEmployeeId}`,
    putHoldEmployeeById: (internalEmployeeId: string) =>
      `/api/Employee/HoldEmployeeById/${internalEmployeeId}`,
    putReleaseEmployeeById: (internalEmployeeId: string) =>
      `/api/Employee/ReleaseEmployeeById/${internalEmployeeId}`,
    FEINS: (clientId: number, taxYear: string) =>
      `/api/Feins/GetFeinsList/${clientId}/${taxYear}`,
    FORMS: (clientId: string, taxYear: string) =>
      `/api/Employee/GetEmployeeList/${clientId}/${taxYear}`,
    getEmployeeAuditHistory: (internalEmployeeId: string) =>
      `/api/Employee/GetEmployeeAuditChanges/${internalEmployeeId}`,
    getEmployeeActivityTimeline: (internalEmployeeId: string) =>
      `/api/Employee/GetEmployeeActivityLog/${internalEmployeeId}`,
    getCompanyAuditHistory: (companySettingsId: string) =>
      `/api/Feins/GetFeinAuditChanges/${companySettingsId}`,
    getCompanyActivityTimeline: (companySettingsId: string) =>
      `/api/Feins/GetFeinActivityLog/${companySettingsId}`,
  },
  USERSSO: {
    getUserSSODetails: (userEmail: string) =>
      `/api/User/GetSsoDetails?userEmail=${userEmail}`,
    updateUserSSODetails: (userEmail: string) =>
      `/api/User/UpdateUserStatus?userEmail=${userEmail}`,
  },
  APPROVALMANAGEMENT: {
    EMPLOYEE: {
      APPROVAL_LIST: (clientId: string, taxYear: string) =>
        `/api/Approval/GetPendingApprovals/${clientId}/${taxYear}`,
      CLIENT_APPROVAL_HISTORY: (clientId: string, taxYear: string) =>
        `/api/Approval/GetClientApprovalHistory/${clientId}/${taxYear}`,
      INTERNAL_APPROVAL_HISTORY: (clientId: string, taxYear: string) =>
        `/api/Approval/GetInternalApprovalHistory/${clientId}/${taxYear}`,
      POST_LEVEL1_APPROVAL: `/api/Approval/Level1ApproveEmployeeForms`,
      PUT_LEVEL2_APPROVE: `/api/Approval/Level2ApproveEmployeeForms`,
      PUT_LEVEL2_REJECT: `/api/Approval/Level2RejectEmployeeForms`,
      STATE_WISE_APPROVAL: (clientId: number, taxYear: number) =>
        `/api/Approval/GetStatewiseCounts/${clientId}/${taxYear}`,
    },

    COMPANY: {
      CLIENT_APPROVAL_OVERVIEW: (clientId: string, taxYear: string) =>
        `/api/Approval/GetCompanyPendingApprovals/${clientId}/${taxYear}`,
      CLIENT_APPROVAL_HISTORY: (clientId: string, taxYear: string) =>
        `/api/Approval/GetCompanyClientApprovalHistory/${clientId}/${taxYear}`,
      INTERNAL_APPROVAL_HISTORY: (clientId: string, taxYear: string) =>
        `/api/Approval/GetCompanyInternalApprovalHistory/${clientId}/${taxYear}`,
      POST_LEVEL1_APPROVAL: `/api/Approval/Level1ApproveCompanyForms`,
      PUT_LEVEL2_APPROVE: `/api/Approval/Level2ApproveCompanyForms`,
      PUT_LEVEL2_REJECT: `/api/Approval/Level2RejectCompanyForms`,
    },
  },
  PRINTFILINGMANAGEMENT: {
    PRINT_DASHBOARD: (taxYear: string) =>
      `/api/Print/GetPrintDashboad/${taxYear}`,
    PENDING_APPROVALS: (clientId: string, taxYear: string) =>
      `/api/Print/GetPendingPrintApprovals/${clientId}/${taxYear}`,
    APPROVALHISTORY: (clientId: string, taxYear: string) =>
      `/api/Print/GetPrintApprovalHistory/${clientId}/${taxYear}`,
    PUT_APPROVE_SUBMISSION: `/api/Print/ApprovePrintSubmission`,
    PUT_REJECT_SUBMISSION: `/api/Print/RejectPrintSubmission`,
    PRINT_SUBMISSION_BATCHES: (clientId: string, taxYear: string) =>
      `/api/Print/GetPrintSubmissionBatches/${clientId}/${taxYear}`,
    PUT_REPRINT_SUBMISSION: (printSubmissionId: string) =>
      `/api/Print/RetryPrintSubmission/${printSubmissionId}`,
    PUT_REPRINT_BATCH: (printBatchId: string) =>
      `/api/Print/RetryPrintBatch/${printBatchId}`,
    FILING_DETAILS: (clientId: number, taxYear: number) =>
      `/api/Filing/GetFilingDetails/${clientId}/${taxYear}`,
    CREATE_FILING_BATCHES: (filingId: string) =>
      `/api/Filing/CreateFilingBatches/${filingId}`,
    FILING_HISTORY: (clientId: string, taxYear: string) =>
      `/api/Filing/GetFilingHistoryDetails/${clientId}/${taxYear}`,
    RETRY_FILING_BATCHES: (filingId: string) =>
      `/api/Filing/GeneratePayloads/${filingId}`,
    FILING_COMPANY_DETAILS: (filingId: number) =>
      `/api/Filing/GetCompanyDetails/Filing/${filingId}`,
    TRANSMISSION_COMPANY_DETAILS: (transmissionId: number) =>
      `/api/Filing/GetCompanyDetails/Transmission/${transmissionId}`,
    FILING_EMPLOYEE_DETAILS: (filingId: number) =>
      `/api/Filing/GetEmployeeDetails/Filing/${filingId}`,
    TRANSMISSION_EMPLOYEE_DETAILS: (transmissionId: number) =>
      `/api/Filing/GetEmployeeDetails/Transmission/${transmissionId}`,
    SUBMIT_FILING: (filingId: number) => `/api/Filing/SubmitFiling/${filingId}`,
    SUBMIT_STATE_TRANSMISSION: (
      transmissionId: number,
      receiptId: string,
      statusCode: number
    ) =>
      `/api/Filing/SubmitStateTransmission/${transmissionId}/${receiptId}/${statusCode}`,
    INITIATE_REPLACEMENT: (transmissionId: number) =>
      `/api/Filing/InitiateReplacement/${transmissionId}`,
  },
  PRINTINDIVIDUALMANAGEMENT: {
    PRINT_INDIVIDUAL_DASHBOARD: `/api/Employee/GetPrintIndividualDashboard`,
    PRINT_INDIVIDUAL_HISTORY: `/api/Print/GetPrintIndividualApprovalHistory`,
    PRINT_INDIVIDUAL_APPROVE: `/api/Print/ApprovePrintIndividualSubmission`,
    PRINT_INDIVIDUAL_CANCEL: `/api/Print/CancelPrintIndividualSubmission`,
    PRINT_INDIVIDUAL_RETRY: (printIndividualSubmissionId: string) => 
      `/api/Print/RetryPrintIndividualSubmission/${printIndividualSubmissionId}`,
    PRINT_INDIVIDUAL_RETRY_BATCH: (printIndividualBatchId: string) => 
      `/api/Print/RetryPrintIndividualBatch/${printIndividualBatchId}`,

  },
  REPORTING: {
    REQUEST_REPORT_GENERATION: (reportType: string, payLoad: string) =>
      `/api/Export/ExportReports/${reportType}/${payLoad}`,
    FETCH_REPORT_STATUS: `/api/Export/GetReportsStatus`,
    FETCH_REPORT_DOWNLOAD: (reportId: number) =>
      `/api/Export/GetReportDownloadLink/${reportId}`,
    CODE_REVIEW: (clientId: string, taxYear: string) =>
      `/api/Approval/GetCodeReviewDetails/${clientId}/${taxYear}`,
    FEIN_REVIEW: (clientId: string, taxYear: string) =>
      `/api/Approval/GetFeinReviewDetails/${clientId}/${taxYear}`,
    STATE_REVIEW: (clientId: string, taxYear: string) =>
      `/api/Approval/GetStatewiseCounts/${clientId}/${taxYear}`,
    COMPANY_AVERAGE_FTE: (clientId: string, taxYear: string) =>
      `api/Report/GetCompanyAverageFte/${clientId}/${taxYear}`,
    IRS_REVIEW_COUNTS: (clientId: string, taxYear: string) =>
      `/api/Report/GetApprovalIrsFeinReviewCounts/${clientId}/${taxYear}`,
    STATE_REVIEW_COUNTS: (clientId: string, taxYear: string) =>
      `/api/Report/GetApprovalStateFeinReviewCounts/${clientId}/${taxYear}`,
    VALIDATION_ERRORS: (clientId: string, taxYear: string) =>
      `/api/Report/GetValidationErrors/${clientId}/${taxYear}`,
    EMPLOYEE_HOLD_FORMS: (clientId: string, taxYear: string) =>
      `/api/Report/GetEmployeeHoldForms/${clientId}/${taxYear}`,
    VALIDATION_ERRORS_SUMMARY: (
      clientId: string,
      taxYear: string,
      type: string
    ) =>
      `/api/Report/GetValidationErrorsSummary/${clientId}/${taxYear}/${type}`,
    ACA_TRANSMISSION_VALIDATION: (clientId: string, taxYear: string) =>
      `/api/Report/GetAcaTransmissionValidation/${clientId}/${taxYear}`,
    CA_TRANSMISSION_VALIDATION: (clientId: string, taxYear: string) =>
      `/api/Report/GetCaTransmissionValidation/${clientId}/${taxYear}`,
    COMPANY_SETTINGS_PART_I_PART_II: (clientId: string, taxYear: string) =>
      `/api/Report/GetCompanySettingsPartIPartIISummary/${clientId}/${taxYear}`,
    COMPANY_SETTINGS_PART_3: (clientId: string, taxYear: string) =>
      `/api/Report/GetCompanySettingsPart3Summary/${clientId}/${taxYear}`,
    PRINT_COUNTS_MONTHLY_SUMMARY: `/api/Report/GetPrintCountsMonthlySummary`,
    SOC1_AUDIT: `/api/Report/GetSoc1AuditClientUsers`,
    IRS_TRANSMISSION_STATUS: (clientId: number, taxYear: number) =>
      `/api/Report/GetTransmissionStatuses/${clientId}/${taxYear}`,
    IRS_ERROR_REPORT: (clientId: number, taxYear: number) =>
      `/api/Report/GetTransmissionErrorDetails/${clientId}/${taxYear}`,
    CA_TRANSMISSION_ERRORS: (clientId: number, taxYear: number) =>
          `/api/Report/GetCaTransmissionErrors/${clientId}/${taxYear}`,
    EMPLOYEE_MANUAL_CHANGE: (clientId: string, taxYear: string) =>
        `/api/Report/GetEmployeeManualChange/${clientId}/${taxYear}`,
    CHANGE_REPORT: (clientId: number, taxYear: number) =>
      `/api/Report/GetMaterialChangesDetails/${clientId}/${taxYear}`,
  },
  EPRESENTMENT: {
    getFormDocumentDetails: (formId: string) =>
      `/api/EPresentment/GetDocumentByFormId/${formId}`,
  },
};

export const Tanstack_QUERY_KEYS = {
  LOOKUP: {
    CLIENTS: "clients",
    FILE_STATUS: "fileStatus",
    TAX_YEARS: "taxYears",
    PRINT_YEARS: "printYears",
    DATA_VALIDATION_LEVELS: "dataValidationLevels",
    ROLES: "roles",
    STATES: "states",
    FileTypes: "fileTypes",
    FeinsByClientId: "feinsByClientId",
    ImportFileTypes: "importFileTypes",
    VALIDATION_ERROR_TYPES: "validationErrorTypes",
  },
  FILEMANAGEMENT: {
    FILE_HISTORY: "fileHistory",
  },
  USERMANAGEMENT: {
    USER_MANAGEMENT: "userManagement",
    USER: "user",
    userSettings: "userSettings",
    getUserSSO: "getUserSSO",
  },
  ACCOUNTSETTINGS: {
    ME: "me",
  },
  CLIENTMANAGEMENT: {
    CLIENT_MANAGEMENT: "clientManagement",
    ALE_GROUP: "aleGroup",
    ALTERNATE_RETURN_ADDRESS: "alternateReturnAddress",
    USE_ALTERNATE_RETURN_ADDRESS: "useAlternateReturnAddress",
    CLIENT_SETTINGS: "clientSettings",
    companySettingsId: "companySettingsId",
    internalEmployeeId: "internalEmployeeId",
    feinManagement: "feinManagement",
    createEmployeeFeins: "createEmployeeFeins",
    formManagement: "formManagement",
    employeeStateFilingSettings: "employeeStateFilingSettings",
    stateFillingSettings: "stateFillingSettings",
    auditHistoryCompany: "auditHistoryCompany",
    auditHistoryEmployee: "auditHistoryEmployee",
    employeeActivityTimeline: "employeeActivityTimeline",
    companyActivityTimeline: "companyActivityTimeline",
  },
  APPROVALMANAGEMENT: {
    APPROVAL_LIST: "approvalList",
    CLIENT_APPROVAL_HISTORY: "clientApprovalHistory",
    INTERNAL_APPROVAL_HISTORY: "internalApprovalHistory",
    COMPANY_CLIENT_APPROVAL_OVERVIEW: "companyClientApprovalOverview",
    COMPANY_CLIENT_APPROVAL_HISTORY: "companyClientApprovalHistory",
    COMPANY_INTERNAL_APPROVAL_HISTORY: "companyInternalApprovalHistory",
  },
  PRINTFILINGMANAGEMENT: {
    PRINT_DASHBOARD: "printDashboard",
    PENDING_APPROVALS: "pendingApprovals",
    APPROVALHISTORY: "approvalHistory",
    PRINT_BATCHES: "printBatches",
    REPRINT_BATCH: "reprintBatch",
    REPRINT_SUBMISSION: "reprintSubmission",
    FILING_DETAILS: "filingDetails",
    FILING_BATCHES: "filingBatches",
    FILING_HISTORY: "filingHistory",
    FILING_COMPANY: "filingCompany",
    FILING_EMPLOYEE: "filingEmployee",
    TRANSMISSION_COMPANY: "transmissionCompany",
    TRANSMISSION_EMPLOYEE: "transmissionEmployee",
  },
  PRINTINDIVIDUALMANAGEMENT: {
    PRINT_INDIVIDUAL_DASHBOARD: "printIndividualDashboard",
    PRINT_INDIVIDUAL_HISTORY: "printIndividualHistory",
    PRINT_INDIVIDUAL_APPROVE: "printIndividualApprove",
    PRINT_INDIVIDUAL_CANCEL: "printIndividualCancel",
    PRINT_INDIVIDUAL_RETRY: "printIndividualRetry",
    PRINT_INDIVIDUAL_RETRY_BATCH: "printIndividualRetryBatch",
  },
  REPORTING: {
    REPORT_DOWNLOAD_STATUS: "reportDownloadStatus",
    CODE_REVIEW: "codeReview",
    FEIN_REVIEW: "feinReview",
    STATE_REVIEW: "stateReview",
    COMPANY_AVERAGE_FTE: "companyAverageFte",
    IRS_REVIEW_COUNTS: "irsCounts",
    STATE_REVIEW_COUNTS: "stateCounts",
    SOC1_AUDIT: "soc1Audit",
    VALIDATION_ERRORS: "validationErrors",
    VALIDATION_ERRORS_SUMMARY: "validationErrorsSummary",
    ACA_TRANSMISSION_VALIDATION: "acaTransmissionValidation",
    CA_TRANSMISSION_VALIDATION: "caTransmissionValidation",
    PRINT_COUNTS_MONTHLY_SUMMARY: "printCountsMonthlySummary",
    COMPANY_SETTINGS_PART_I_PART_II: "companySettingsPartIPartII",
    COMPANY_SETTINGS_PART_3: "companySettingsPart3",
    IRS_TRANSMISSION_STATUS: "irsTransmissionStatus",
    IRS_ERROR_REPORT: "irsErrorReport",
    CA_TRANSMISSION_ERRORS: "caTransmissionErrors",
    EMPLOYEE_HOLD_FORMS: "employeeHoldForms",
    CHANGE_REPORT: "changeReport",
    CLIENT_STATE_FILING_OPTIONS: "clientStateFilingOptions",
    EMPLOYEE_PART_II_CENSUS: "employeePartIICensus",
    EMPLOYEE_MANUAL_CHANGE: "employeeManualChange",
  },
  EPRESENTMENT: "formDocument",
};

export const DEFALUT_PAGE_SIZE = Number(import.meta.env.VITE_PAGE_SIZE ?? 100);
export const DEFAULT_MAX_PAGES = Number(import.meta.env.VITE_MAX_PAGES ?? 10);
export const STATE_MAP = {
  ca: "CA State Filing",
  dc: "DC State Filing",
  nj: "NJ State Filing",
  ri: "RI State Filing",
} as const;
